import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../../services/blog.service';

@Component({
  selector: 'app-blog-sidebar',
  templateUrl: './blog-sidebar.component.html',
  styleUrl: './blog-sidebar.component.scss'
})
export class BlogSidebarComponent implements OnInit {

  blogs: any[] = [];
  constructor(private blogService: BlogService) { }

  ngOnInit(): void {
    this.blogService.getBlogs(1, 3).subscribe({
      next: (data) => this.blogs = data.data,
      error: (err) => console.error('Failed to load blog data:', err)
    });
  }
  onImageError(event: any): void {
    event.target.src = '/assets/img/noimage.png';
  }
}